import RestrictGoal from './RestrictGoal';

export default RestrictGoal;
